<div class="cart-page" *ngIf="cart$ | async as cart">
  <div class="cart-header">
    <h1>Cart</h1>
    <div class="cart-summary" *ngIf="!cart.isEmpty">
      <span>{{ getTotalQuantity(cart) }} Extra XCO{{ getTotalQuantity(cart) > 1 ? 's' : '' }} (ADDP{{ getTotalQuantity(cart) > 1 ? 's' : '' }})</span>
      <span class="separator">•</span>
      <span>{{ formatCartTotal(cart) }}</span>
    </div>
  </div>

  <div *ngIf="cart.isEmpty" class="cart-empty">
    <p>Your cart is empty.</p>
  </div>

  <div *ngIf="!cart.isEmpty" class="cart-items">
    <div class="cart-item-card" *ngFor="let item of cart.items; trackBy: trackByItem">
      <div class="item-content">
        <div class="item-info">
          <h3>{{ formatTitle(item) }}</h3>
          <p class="technical-pop-name" *ngIf="getOriginalXco(item) as originalXco">
            <span class="original-xco-label">Original XCO : {{ originalXco }} ·</span>
            <span *ngIf="getTechnicalPopName(item) as technicalPopName">&nbsp;{{ technicalPopName }}</span>
          </p>
          <p class="item-quantity">Quantity: {{ getQuantity(item) }}</p>
          <p class="product-list">{{ formatProductList(item) }}</p>
        </div>
        <div class="item-actions">
          <div class="item-pricing">
            <div class="item-price">{{ formatLineTotal(item) }}</div>
            <div class="item-unit-price">{{ formatPrice(item) }} / unit</div>
          </div>
          <div class="quantity-controls">
            <button class="quantity-btn" type="button"
                    [disabled]="isQuantityUpdating(item) || getQuantity(item) <= 1"
                    (click)="updateQuantity(item, -1)">
              <i class="fa fa-minus"></i>
            </button>
            <span class="quantity-value" [class.quantity-value--loading]="isQuantityUpdating(item)">
              <i class="fa fa-spinner fa-spin" *ngIf="isQuantityUpdating(item)"></i>
              <ng-container *ngIf="!isQuantityUpdating(item)">{{ getQuantity(item) }}</ng-container>
            </span>
            <button class="quantity-btn" type="button"
                    [disabled]="isQuantityUpdating(item)"
                    (click)="updateQuantity(item, 1)">
              <i class="fa fa-plus"></i>
            </button>
          </div>
          <button class="icon-btn" type="button"
                  [disabled]="removingItemUuid === item.uuid || isQuantityUpdating(item)"
                  (click)="confirmRemove(item)">
            <i class="fa fa-trash" *ngIf="removingItemUuid !== item.uuid"></i>
            <i class="fa fa-spinner fa-spin" *ngIf="removingItemUuid === item.uuid"></i>
          </button>
        </div>
      </div>
      <div class="item-footer">
        <button type="button" class="secondary-btn" [disabled]="isQuantityUpdating(item)" (click)="openEdit(item)">
          Edit
        </button>
      </div>
    </div>
  </div>

  <div class="cart-footer" *ngIf="!cart.isEmpty">
    <button
      type="button"
      class="primary-btn"
      [disabled]="cart.isEmpty || confirmingOrder"
      (click)="openConfirmOrder(cart)"
    >
      <ng-container *ngIf="!confirmingOrder">Confirm Order</ng-container>
      <ng-container *ngIf="confirmingOrder">
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        &nbsp;Submitting...
      </ng-container>
    </button>
  </div>
</div>

<app-cart-addp-edit-dialog
  [item]="editingItem"
  [visible]="editDialogVisible"
  (visibleChange)="onEditDialogVisibilityChange($event)"
></app-cart-addp-edit-dialog>
